<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-form ref="formTransferValidation" role="form">
			<v-card>
				<v-card-title class="h6 justify-start"><v-icon class="mr-2">mdi-lock</v-icon>Tambah PIN Keamanan</v-card-title>
				<v-card-text class="text-left pb-0">
					<p class="font-size-12"><b class="cl-primary">PIN Keamanan adalah verifikasi 2 langkah untuk meningkatkan keamanan ber-transaksi.</b></p>
					<p class="mb-0">Masukkan 6-digit PIN, harus berupa angka. Hindari menggunakan kombinasi angka yang mudah ditebak, seperti tanggal lahir atau nomor ponsel.</p>
				</v-card-text>
				<v-card-text class="text-left">
					<div class="d-block text-left mb-3">
						<div class="d-flex">
							<div class="pa-0 col-12 col-sm-12">
								<v-sheet outlined color="dark" rounded class="mt-4 mb-2 pa-50">
									<v-card outlined elevation="0" class="px-5 pt-3 pb-5">
										<v-text-field id="setPin" ref="setPin" label="Masukkan PIN Anda" class="input-regis" prepend-inner-icon="mdi-lock" tabindex="1" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" hide-details="auto" :rules="rules.member_account_pin" v-model="member_account_pin" autofocus></v-text-field>
										<div v-if="errorValidation['member_account_pin']" class="pt-1 font-size-10 red--text">{{ errorValidation['member_account_pin'] }}</div>
									</v-card>
								</v-sheet>
							</div>
						</div>
						<div class="pt-1 d-flex">
							<div class="pa-0 col-12 col-sm-12">
								<v-sheet outlined color="dark" rounded class="mt-4 mb-2 pa-50">
									<v-card outlined elevation="0" class="px-5 pt-3 pb-5">
										<v-text-field id="setPin2" ref="setPin2" label="Ulangi PIN Anda" class="input-regis" prepend-inner-icon="mdi-lock" tabindex="2" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" hide-details="auto" :rules="rules.member_account_pin_confirmation" v-model="member_account_pin_confirmation"></v-text-field>
										<div v-if="errorValidation['member_account_pin_confirmation']" class="pt-1 font-size-10 red--text">{{ errorValidation['member_account_pin_confirmation'] }}</div>
									</v-card>
								</v-sheet>
							</div>
						</div>
					</div>
				</v-card-text>
				<v-card-actions class="pb-4">
					<v-spacer></v-spacer>
					<v-btn color="primary" depressed class="text-capitalize" tabindex="3" :loading="btnLoading" @click.stop="setNewPin">{{ confirmText }}</v-btn>
					<v-btn color="grey darken-1" outlined class="text-capitalize" tabindex="4" :loading="btnLoading" @click.stop="modalHide">{{ closeText }}</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
	data () {
		return {
			member_account_pin: '',
			member_account_pin_confirmation: '',
			typeInput0: 'password',
			icon0: 'mdi-eye',
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Tidak, nanti saja',
			confirmText: 'Submit PIN',
			rules: {
				member_account_pin: [
					v => !!v || 'PIN tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "PIN tidak boleh kurang dari 6 angka",
					v => ( v && v.length < 7 ) || "PIN tidak boleh lebih dari 6 angka"
				],
				member_account_pin_confirmation: [
					v => !!v || 'PIN tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "PIN tidak boleh kurang dari 6 angka",
					v => ( v && v === this.member_account_pin ) || "PIN yang anda masukkan tidak cocok",
				],
			},
		}
	},
	props: [ 'msg', 'datamsg', 'isActiveMember' ],
	computed: {
		...mapState('ewallet', ['errorValidation'])
	},
	methods: {
		...mapActions('ewallet', ['setPinMitra', 'setPinPramitra']),

		showPassword0() {
			this.typeInput0 = this.typeInput0 == 'text' ? 'password' : 'text'
			this.icon0 = this.icon0 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		modalHide() {
			this.member_account_pin = ''
			this.member_account_pin_confirmation = ''
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		loadingButton() {
			this.btnLoading = true
		},
		normalButton() {
			this.btnLoading = false
		},
		setNewPin() {
			const params = {
				member_account_pin: this.member_account_pin,
				member_account_pin_confirmation: this.member_account_pin_confirmation
			}

			if (this.$refs.formTransferValidation.validate()) {
				this.btnLoading = true
				if(this.isActiveMember) {
					this.setPinMitra(params).then(() => {
						if (this.datamsg.code && this.datamsg.nominal) {
							this.confirm()
						} else {
							this.modalHide()
						}
						this.btnLoading = false
					}).catch(() => {
						this.btnLoading = false
					})
				} else {
					this.setPinPramitra(params).then(() => {
						if (this.datamsg.code && this.datamsg.nominal) {
							this.confirm()
						} else {
							this.modalHide()
						}
						this.btnLoading = false
					}).catch(() => {
						this.btnLoading = false
					})
				}
			}

		},
		confirm() {
			this.$emit('action')
			this.modalHide()
		}
	},
	mounted() {
	},
};
</script>